// Строка состояния: элементы registry.statusbar (слева и справа).
import { registry } from '../core/registry';
import { ctx } from '../core/ctx';
import { useRegistry } from './hooks';

export function StatusBar() {
  const items = useRegistry(registry.statusbar);
  return (
    <div className="statusbar" data-testid="statusbar" role="status" aria-live="off">
      <div className="status-left">{items.filter((i) => i.side === 'left').map((i) => <i.component key={i.id} ctx={ctx} />)}</div>
      <div className="status-right">{items.filter((i) => i.side === 'right').map((i) => <i.component key={i.id} ctx={ctx} />)}</div>
    </div>
  );
}
